import css from './test.module.scss';

import { memo } from 'react';

import Option from './Option';
import QuestionHeader from './QuestionHeader';
import { TAuxQuestion } from './types';

type Props = {
  question: TAuxQuestion;
  selection: number | null;
  isDue: boolean;
  onSelect: (idx: number) => void;
};

function Question({
  question,
  selection,
  isDue,
  onSelect: onSelectProp,
}: Props) {
  return (
    <>
      <QuestionHeader question={question} selection={selection} isDue={isDue} />
      <div className={css.answersWrapper}>
        <div
          className={css.answers}
          // Reset pseudo-hover effect on mobiles.
          key={question.uid}
        >
          {question.options.map((answer, idx) => (
            <Option
              disabled={selection != null}
              selected={
                // prettier-ignore
                selection == null
                ? undefined
                : idx === selection && selection !== question.rightOption
                  ? 'wrong'
                  : idx === question.rightOption
                    ? 'right'
                    : undefined
              }
              key={idx}
              idx={idx}
              answer={answer}
              onClick={() => onSelectProp(idx)}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default memo(Question);
